package dev.iad.portfoliowebsite.data

import dev.iad.portfoliowebsite.models.Experience

internal val EXPERIENCES = listOf(
    Experience(
        company = "trivago",
        position = "Mobile Software Engineer III",
        summary = "Developed and enhanced the trivago hotel search Android app within a cross-functional team, leading tech initiatives and mentoring peers.",
        end = "present",
        start = "2022"
    ),
    Experience(
        company = "Headspace Health (formerly Ginger)",
        position = "Senior Software Engineer",
        summary = "Contributed to the Ginger Care mobile app, working on features including user and content management. In addition, I participated in implementing technical projects that resulted in increased user base and improved dev experience.",
        end = "2022",
        start = "2021"
    ),
    Experience(
        company = "Autochek Africa",
        position = "Android Engineer",
        summary = "Worked in a startup team to develop and release the Autocheck car marketplace Android app including features as ad-placements/uploads, financing application process, purchase payments, user authentication, etc.",
        end = "2021",
        start = "2020"
    ),
    Experience(
        company = "Andela <> Intentional Futures",
        position = "Software Engineer",
        summary = "Proceeded through the Andela apprenticeship program to work with Intentional Futures developing multiple web and full-stack projects.",
        end = "2021",
        start = "2017"
    )
)
